const Form009SC = {
    stepName: {
        statement: "重要提示",
        applicationInfo: "申请讯息",
        confirmation: "确认页",
    },

    errorMsg: {
        cl: "上述选项必填一个",
        atLeastOne: "至少填写一条地点及日期",
    },
    headTitle: {
        teacher: "随团教师申请表",
        headerLetter: "校长推荐书（教师适用）",
    },
    colon: "：",
    label: {
        photographs: "正面半身近照",
        chineseName: "获提名教师中文姓名",
        englishName: "获提名教师英文姓名",
        idNum: "身份证号码",
        addressPhone: "住宅电话",

        mobilePhone: "流动电话",

        taughtSchool: "任教学校",
        schoolAddress: "学校地址",
        schoolPhone: "学校电话",
        schoolFax: "学校传真",
        schoolName: "学校名称",
        masterName: "校长姓名",
        masterPhone: "学校电话",
        // applicantSign: "申请人签署",
    },
    label1: {
        header: {
            headerOne: "收集申请者个人资料声明",
        },
        content: {
            contentOne: "拟提名学生及/或教师参加上述交流团的学校须于",
            contentTwo: "2020年2月24日（星期一）或以前",
            contentThree:
                "把填妥的申请表格，连同所需的文件送交本团办事处。为免邮递失误而泄漏申请人的个人资料，团办事处鼓励学校以专人送交或采用挂号邮寄方式递交申请。如选择以邮寄方式递交申请，为免影响邮件派递，请确保邮资足够。",
            contentFour: "逾期申请恕不考虑",
            contentFive: "（邮寄申请以邮戳日期为准）",
        },
        // serialOption: {
        //     a: "(a)",
        //     b: "(b)",
        //     c: "(c)",
        //     d: "(d)",
        //     e: "(e)",
        //     f: "(f)",
        // },
        // useOption: {
        //     a: "办理与聘用有关的事宜；",
        //     b: "处理发放薪金津贴，以及计算公积金的供款和赠款；",
        //     c: "进行核数工作；",
        //     d: "进行研究及统计资料，以便规划教育服务；",
        //     e: "处理有关教育专业人员发展的事宜；",
        //     f: "执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》（第279章）。",
        // },
        // doc: {
        //     d1: "个人资料收集声明",
        //     d2: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途：",
        //     d3: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        //     d4: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        //     d5: "根据《个人资料（私隐）条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        //     d6: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
        // },

        statementCon: {
            text1: "随团教师所提交的个人资料及相关文件（如个人资料表及证件影印本等），将用于处理参加交流团之用。参加者如未能提供所需资料，有关申请将不获受理。",
            text2: "教育局会按需要，将个人资料送交获授权处理的航运机构、酒店、旅行社、保险公司或相关单位，以便安排学习、交流、参访、住宿、交通及紧急医疗等事宜。",
            text3: "所有个人资料及相关文件（包括个人资料表及证件影印本等）将于交流团完结后销毁。",
            text4: "获提名参加者有权根据《个人资料（私隐）条例》（香港特别行政区法例第486章）第18和22条，以及附表1第6项原则规定，查阅和更正所提供的个人资料。如对参加交流团所收集的个人资料有任何查询，包括查阅及更正数据，请联络香港湾仔皇后大道东213号胡忠大厦11楼1141室教育局公益少年团办事处（电话：2892 6660）。",
        },

        statement: "本人已阅读、明白及同意上述条款及细则",
    },
    label2: {
        sex: "性别",
        sexOption: {
            Male: "男",
            Female: "女",
        },

        canLanguage: "能操语言",
        languageOption: {
            cantonese: "广东话",
            english: "英语",
            mandarin: "普通话",
            korean: "韩语",
            other: "其他（请注明）",
        },
        languageNewOption: {
            cantonese: "广东话",
            english: "英语",
            mandarin: "普通话",
            other: "其他（请注明）",
        },
        otherNote1: "请注明",
        languageDocument: "外语证书",
    },
    label3: {
        birthDate: "出生日期",
    },
    publicServiceDate: {
        t1: "本人自",
        t2: "至今于本校担任公益少年团导师，现时团员人数约",
        t3: "人",
        t4: "正整数",
    },

    interest: "兴趣/专长",

    signNote:
        "本人答应一旦获选为2020年公益少年团杰出团员交流团的随团教师，将会出席所有出发前的会议、训练及回港后的汇报日，并全程带领及指导团员参与各项交流活动及协助团员完成交流成果报告。",
    sign: "申请人签署",
    signDate: "日期",
    memberStatement: "收集申请者个人资料声明",
    personConfirm: {
        p: "收集申请者个人资料声明",
        p1: "{{person}}所提交的个人资料及相关文件（如个人资料表及证件影印本等），将用于处理参加交流团之用。参加者如未能提供所需资料， 有关申请将不获受理。",
        p2: "教育局会按需要，将个人资料送交获授权处理的航运机构、酒店、旅行社、保险公司或相关单位，以便安排学习、交流、参访、住宿、交通及紧急医疗等事宜。",
        p3: "所有个人资料及相关文件（包括个人资料表及证件影印本等）将于交流团完结后销毁。",
        p4: "获提名参加者有权根据《个人资料（私隐）条例》（香港特别行政区法例第 486 章）第 18 和 22 条，以及附表 1 第 6 项原则规定，查阅和更正所提供的个人资料。如对参加交流团所收集的个人资料有任何查询，包括查阅及更正数据，请联络香港湾仔皇后大道东 213 号胡忠大厦 11 楼 1141 室教育局公益少年团办事处（电话2892 6660）。",
    },
    applicantInfo: {
        information: "获提名教师资料",
        name: "获提名教师姓名",
        chineseName: "获提名教师姓名（中文）",
        englishName: "获提名教师姓名（英文）",
        conduct: "获提名教师人品行",
        perseverance:
            "获提名教师在负责公益少年团活动方面的表现（例如做事的积极性、责任感、态度等）",
        ability: "获提名教师的语言能力（1 分最低至 5 分最高）",
        threeLanguageOption: {
            mandarin: "普通话",
            english: "英语",
        },
        threeScoreOption: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
        },
        comment: "其他评语 / 备注",
    },

    teacherApp: {
        activity: "简述曾负责的公益少年团活动",
        award: "已获颁授的公益少年团功绩荣誉奖励计划奖项",
        appreciationForOneYearOfService: "感谢状（已服务一年）",
        appreciationForTwoYearOfService: "感谢状（已服务二年）",
        recognitionCertificateTwoToFourYears: "嘉许状（已服务三至四年）",
        recognitionCertificateSpecialNomination:
            "嘉许状（只服务一、两年但获特殊破格提名）",
        loyalServiceAward: "忠诚服务奖",
        goodServiceAward: "良好服务奖",
        excellentServiceAward: "优异服务奖",
        bronzeMedal: "铜章",
        silverMedal: "银章",
        overseaExchange:
            "曾否带领学生进行境外交流活动（如有，请列出最近两次地点及日期）",
        exchangeOption: {
            yes: "有",
            no: "没有",
        },
        haveNote: {
            h1: "（1）",
            h2: "（2）",
        },
        site: "地点",
        date: "日期",
        aid: "是否持有有效急救证书",
        aidDate: "有效期至",
        aidDocument: "急救证书",
    },
    teacherLet: {
        position: "获提名教师职位",
        positionOption: {
            pO1: "副校长",
            pO2: "主任",
            pO3: "教师",
        },
        service: {
            y1: "获提名教师于本校服务公益少年团年资：",
            y2: "年",
        },
    },
    changeTitle: {
        c1: "{{year}}年公益少年团杰出团员{{country}}交流团",
    },
    promise: {
        p1: "本人谨此确认如本人获选为{{year}}年公益少年团{{country}}杰出团员交流团的随团教师，定必出席所有出发前的筹备会议、训练及交流结束后的小组报告汇报日，并全程带领及指导团员参与各项交流活动及协助团员完成交流成果的小组报告。",
    },
};
export default Form009SC;
